<template>
    <div id="app-root">
        <component v-bind:is="layout"></component>
        <noti-modal v-show="false" :isGlobal="true"></noti-modal>
    </div>
</template>
<script>
import LoadingLayout from "./layout/LoadingLayout";
import ErrorLayout from "./layout/ErrorLayout";
import EmptyLayout from './layout/EmptyLayout';
import PreviewLayout from './layout/PreviewLayout';
import AppLayout from './layout/AppLayout.vue';
import AuthLayout from './layout/AuthLayout.vue';
import notiModal from "./modal/home/noti/notiModal.vue";

export default {
    computed: {
        layout() {
            return this.$route.meta.layout || this.$store.getters.layout
        }
    },
    components: {
        'error-layout': ErrorLayout,
        'loading-layout': LoadingLayout,
        'empty-layout': EmptyLayout,
        'preview-layout': PreviewLayout,
        'app-layout': AppLayout,
        'auth-layout': AuthLayout,
        'noti-modal': notiModal,
    }
}
</script>
<style>
#app-root {
    width: 100%;
    height: 100%;
}
</style>
